module.exports = __webpack_public_path__ + "fonts/Beeline_Sans-Bold.ef369c1f.ttf";